import { IStore } from "./IStore";

export interface IBadGeocode {
  recordNumber: number;
  store: IStore;
}
